import {createApi,fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { Sep30ExternalAuthParams, Sep30ExternalAuthResponseParams, Sep30GetAddressParams, Sep30GetAddressParamsResponse, Sep30GetTransactionParams, Sep30RecoverAccountParams, Sep30RecoverAccountResponse, Sep30RegistrationRequestParams, Sep30RegistrationResponse, Sep30TokenVerifyResponseParams, Sep30VerifyPhoneParams } from '../../../types/stellarseps';

const startAccountRegistration = async(params:Sep30RegistrationRequestParams):Promise<[any,Sep30RegistrationResponse|null]>=>{

    let responseError:any;
    
    const url = params.domain;
    
    if (!url){

        responseError = new Error('SEP30 URL not available')

    }
        try {

            const axiosConfig: AxiosRequestConfig = {
                method: "post",
                url: `${url}/sep30/accounts/${params.account}`,
                data:{identities:params.identities},
                headers: {'Authorization': 'Bearer '+params.auth_token}
            };

            const axiosResponse = await axios.request(axiosConfig);

            const identityResponse = axiosResponse.data;

            return [null,identityResponse as Sep30RegistrationResponse]

        } catch (axiosError) {

            const err = axiosError as AxiosError;

            return [err,null]
        }
    

    

}

const signTransaction = async(params:Sep30RecoverAccountParams):Promise<[any,Sep30RecoverAccountResponse|null]>=> {

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "post",
            url: `${params.domain}/sep30/accounts/${params.accountToRecover}/sign/${params.recoveryServerAccount}`,
            data:{transaction:params.transaction},
            headers: {'Authorization': 'Bearer '+params.auth_token}
        };

        const axiosResponse = await axios.request(axiosConfig);

        const signingResponse = axiosResponse.data;

        return [null,signingResponse as Sep30RecoverAccountResponse]

    } catch (axiosError) {

        const err = axiosError as AxiosError;

        return [err,null]
    }


}

const getTransaction = async(params:Sep30GetTransactionParams):Promise<[any,Sep30RecoverAccountResponse|null]>=>{

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${params.domain}/sep30/transactions/${params.id}`,
            headers: {'Authorization': 'Bearer '+params.auth_token}
        };

        const axiosResponse = await axios.request(axiosConfig);

        const response = axiosResponse.data;

        return [null,response as Sep30RecoverAccountResponse]

    } catch (axiosError) {

        const err = axiosError as AxiosError;

        return [err,null]
    }

}

const getPhoneToken = async(params:Sep30ExternalAuthParams):Promise<[any,Sep30ExternalAuthResponseParams|null]>=>{

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${params.auth_url}`,
            params:{
                method:params.method,
                value:params.value
            }
        };

        const axiosResponse = await axios.request(axiosConfig);

        const response = axiosResponse.data;

        return [null,response as Sep30ExternalAuthResponseParams]

    } catch (axiosError) {

        const err = axiosError as AxiosError;

        return [err,null]
    }

}

const verifyToken = async (params:Sep30VerifyPhoneParams):Promise<[any,Sep30TokenVerifyResponseParams|null]>=>{

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "post",
            url: `${params.base_url}/verify/token`,
            data:{

                id:params.id,
                token:params.token
            },
            headers: {'Authorization': 'Bearer '+params.auth_token}
        };

        const axiosResponse = await axios.request(axiosConfig);

        const response = axiosResponse.data;

        return [null,response as Sep30TokenVerifyResponseParams]

    } catch (axiosError) {

        const err = axiosError as AxiosError;

        return [err,null]
    }

}

const getRecoveryAddress = async(params:Sep30GetAddressParams):Promise<[any,Sep30GetAddressParamsResponse|null]>=>{

    try {

        const axiosConfig: AxiosRequestConfig = {
            method: "get",
            url: `${params.base_url}/sep30/accounts/${params.address}`,
            headers: {'Authorization': 'Bearer '+params.auth_token}
        };

        const axiosResponse = await axios.request(axiosConfig);

        const response = axiosResponse.data;

        return [null,response as Sep30GetAddressParamsResponse]

    } catch (axiosError) {

        const err = axiosError as AxiosError;

        return [err,null]
    }


}

export const recoveryServerApi = createApi({
    reducerPath:"recoveryServerApi",
    baseQuery: fetchBaseQuery({ baseUrl: '/ ' }),
    endpoints: (builder) => ({
        
        registerAccount: builder.mutation<Sep30RegistrationResponse, Sep30RegistrationRequestParams>({   
            async queryFn(_arg){

                const [error,response] = await startAccountRegistration(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30RegistrationResponse,}     
            },
        }),
        signRecoverAccountTransaction:builder.mutation<Sep30RecoverAccountResponse, Sep30RecoverAccountParams>({   
            async queryFn(_arg){

                const [error,response] = await signTransaction(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30RecoverAccountResponse}     
            },
        }),
        getTransaction:builder.query<Sep30RecoverAccountResponse, Sep30GetTransactionParams>({   
            async queryFn(_arg){

                const [error,response] = await getTransaction(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30RecoverAccountResponse}     
            },
        }),
        getPhoneToken:builder.query<Sep30ExternalAuthResponseParams,Sep30ExternalAuthParams >({   
            async queryFn(_arg){
                
                const [error,response] = await getPhoneToken(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30ExternalAuthResponseParams}     
            },
        }), 
        verifyToken: builder.mutation<Sep30TokenVerifyResponseParams, Sep30VerifyPhoneParams>({   
            async queryFn(_arg){

                const [error,response] = await verifyToken(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30TokenVerifyResponseParams,}     
            },
        }),
        getRecoveryAddress:builder.query<Sep30GetAddressParamsResponse,Sep30GetAddressParams >({   
            async queryFn(_arg){
                
                const [error,response] = await getRecoveryAddress(_arg);

                if (error){
                    return {error:error,data:undefined}
                }
                
                return {error:undefined,data: response as Sep30GetAddressParamsResponse}     
            },
        }), 
    })
})

export const {useRegisterAccountMutation,useSignRecoverAccountTransactionMutation,useGetTransactionQuery,useGetPhoneTokenQuery,useVerifyTokenMutation} = recoveryServerApi         
